import apiClient from './api';

export interface FAQItem {
  id: number;
  question: string;
  answer: string;
  type: string;
}

export interface FAQType {
  name: string;
  displayName: string;
}

export const faqService = {
  getFAQs: async (type?: string, page?: number, size?: number): Promise<FAQItem[]> => {
    const params: any = {};
    if (type) params.type = type;
    if (page !== undefined) params.page = page;
    if (size !== undefined) params.size = size;

    const response = await apiClient.get<FAQItem[]>('/faqs', { params });
    return response.data;
  },

  getFAQTypes: async (): Promise<FAQType[]> => {
    const response = await apiClient.get<FAQType[]>('/faqs/types');
    return response.data;
  },
};
